import { ProductInventoryUpsertSchema } from "@redotech/redo-product2-common/product2-inventory-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const upsertProductAndInventoryAtLocation = unaryRpc({
  name: "upsertProductAndInventoryAtLocation" as const,
  input: z.object({
    location: z.string(),
    team: z.string(),
    product: ProductInventoryUpsertSchema,
  }),
  output: z.object({ success: z.boolean() }),
});
